<template>
    <ModalBase v-if="visible" :with-content="true" @close="cancel">
        <h1>Edit Ladder</h1>
        <section>
            <label sm="4"> <label>Fixed:</label> </label> <label sm="8"> <b-form-checkbox v-model="fixed"></b-form-checkbox> </label>
        </section>
        <section>
            <label sm="4"> <label>X:</label> </label> <label sm="8"> <NumberInput v-model="x"></NumberInput> </label>
        </section>
        <section>
            <label sm="4"> <label>Top:</label> </label> <label sm="8"> <NumberInput v-model="top"></NumberInput> </label>
        </section>
        <section>
            <label sm="4"> <label>Bottom:</label> </label> <label sm="8"> <NumberInput v-model="bottom"></NumberInput> </label>
        </section>
        <section>
            <label sm="4"> <label>Top Pawl:</label> </label> <label sm="8"> <NumberInput v-model="topPawl"></NumberInput> </label>
        </section>
        <section>
            <label sm="4"> <label>Bottom Pawl:</label> </label> <label sm="8"> <NumberInput v-model="bottomPawl"></NumberInput> </label>
        </section>
        <section>
            <label sm="4"> <label>Pawl Interval:</label> </label> <label sm="8"> <NumberInput v-model="pawlInterval"></NumberInput> </label>
        </section>
        <footer style="float: right; margin-top: 5px">
            <ClientColorButton @click="validate">{{ $trad.common.ok }}</ClientColorButton>
            <ClientColorButton @click="cancel">{{ $trad.common.cancel }}</ClientColorButton>
        </footer>
    </ModalBase>
</template>

<script>
import { Context } from "plano_engine";
import NumberInput from "../components/number-input";
import ModalBase from "@/components/modal/ModalBase";
import ClientColorButton from "@/components/ui/ClientColorButton";

let editBoardLadderWidget;
window.editBoardLadder = function editBoardLadder(data, onValidate, onCancel) {
    const parent = data.element.parent();
    editBoardLadderWidget.setElement(data.element);
    editBoardLadderWidget.fixed = data.fixed;
    editBoardLadderWidget.x = data.x + parent.width / 2 / Context.rescaleFactor;
    editBoardLadderWidget.top = data.top + parent.height / 2 / Context.rescaleFactor;
    editBoardLadderWidget.bottom = parent.height / 2 / Context.rescaleFactor - data.bottom;
    editBoardLadderWidget.topPawl = data.topPawl + data.element.height / 2 / Context.rescaleFactor;
    editBoardLadderWidget.bottomPawl = data.element.height / 2 / Context.rescaleFactor - data.bottomPawl;
    editBoardLadderWidget.pawlInterval = data.pawlInterval;
    editBoardLadderWidget.visible = true;
    editBoardLadderWidget.onValidate = onValidate;
    editBoardLadderWidget.onCancel = onCancel;
};

function preview() {
    if (this.element) {
        const parent = this.element.parent();

        const top = parseFloat(this.top) - parent.height / 2 / Context.rescaleFactor;
        const bottom = parent.height / 2 / Context.rescaleFactor - parseFloat(this.bottom);
        const height = -top + bottom;
        this.element.update({
            x: parseFloat(this.x) - parent.width / 2 / Context.rescaleFactor,
            top,
            bottom,
            fixed: this.fixed,
            topPawl: parseFloat(this.topPawl) - height / 2,
            bottomPawl: height / 2 - parseFloat(this.bottomPawl),
            pawlInterval: parseFloat(this.pawlInterval)
        });
    }
}

export default {
    components: {
        NumberInput,
        ModalBase,
        ClientColorButton
    },
    data() {
        return {
            x: 0,
            top: 0,
            bottom: 0,
            topPawl: 0,
            bottomPawl: 0,
            pawlInterval: 0,
            fixed: false,
            visible: false,
            onValidate: undefined,
            onCancel: undefined
        };
    },
    created() {
        editBoardLadderWidget = this;
    },
    watch: {
        x: preview,
        top: preview,
        bottom: preview,
        fixed: preview,
        topPawl: preview,
        bottomPawl: preview,
        pawlInterval: preview
    },
    methods: {
        setElement(element) {
            this.element = element;
            Context.memento.open();
        },
        validate() {
            const parent = this.element.parent();

            const top = parseFloat(this.top) - parent.height / 2 / Context.rescaleFactor;
            const bottom = parent.height / 2 / Context.rescaleFactor - parseFloat(this.bottom);
            const height = -top + bottom;
            this.onValidate({
                x: parseFloat(this.x) - parent.width / 2 / Context.rescaleFactor,
                top,
                bottom,
                fixed: this.fixed,
                topPawl: parseFloat(this.topPawl) - height / 2,
                bottomPawl: height / 2 - parseFloat(this.bottomPawl),
                pawlInterval: parseFloat(this.pawlInterval)
            });
            this.clear();
        },
        cancel() {
            this.onCancel();
            Context.memento.undo();
            this.clear();
        },
        clear() {
            this.element = undefined;
            this.x = 0;
            this.top = 0;
            this.bottom = 0;
            this.topPawl = 0;
            this.bottomPawl = 0;
            this.pawlInterval = 0;
            this.fixed = false;
            this.visible = false;
            this.onValidate = undefined;
            this.onCancel = undefined;
        }
    }
};
</script>

<style lang="scss" scoped>
section {
    margin: 10px 0px;
}

input {
    float: right;
}
</style>



// WEBPACK FOOTER //
// edit_board_ladder.vue?470daab8